import React, { useState, useEffect } from "react";
import { Button, Input, Select } from "antd";
import { useNavigate, useParams } from "react-router-dom";
import { getCountries, getCountryCallingCode } from "react-phone-number-input/input";
import { ErrorToast, SuccessToast } from "../../../widgets/AppToast";
import { post } from "../../../services/services";
import { ApiURL } from "../../../services/apiConstants";
import { CountryDropdown } from "react-country-region-selector";
import moment from "moment";
import CurrencyDropdown, { getCurrencySymbol } from "../../../components/CurrencyDropdown";

const EditStaff = () => {
  const { staff_id } = useParams();
  const navigate = useNavigate();
  const [loader, set_loader] = useState(false);
  const [errors, set_errors] = useState({});
  const [role_permission_id, set_role_permission_id] = useState("");
  const [first_name, set_first_name] = useState("");
  const [last_name, set_last_name] = useState("");
  const [email, set_email] = useState("");
  const [date_of_birth, set_date_of_birth] = useState("");
  const [seafarer_id, set_seafarer_id] = useState("");
  const [nationality, set_nationality] = useState("");
  const [list_roll_permission, set_list_roll_permission] = useState([]);
  const [securityCode, setSecurityCode] = useState("");
  const [errorSecurity, setErrorSecurity] = useState("");
  const [department, setDepartment] = useState("");
  const [activeOvertime, setActiveOvertime] = useState(false);

  const [currency, setCurrency] = useState("");
  const [base_salary, setBase_salary] = useState(0);
  const [fixed_overtime_hours, setFixed_overtime_hours] = useState(0);
  const [fixed_overtime_pay, setFixed_overtime_pay] = useState(0);
  const [per_hour_overtime_pay, setPer_hour_overtime_pay] = useState(0);

  const [signOnDate, setSignOnDate] = useState("");
  const [expectedSignOffDate, setExpectedSignOffDate] = useState("");
  const [actualSignOffDate, setActualSignOffDate] = useState("");

  const [selectedSlots, setSelectedSlots] = useState([]);
  const [isDragging, setIsDragging] = useState(false);
  const [dragMode, setDragMode] = useState("add");
  const [initialData, setInitialData] = useState({});

  const clearError = (fieldName) => {
    if (errors[fieldName]) {
      set_errors((prev) => {
        const newErrors = { ...prev };
        delete newErrors[fieldName];
        return newErrors;
      });
    }
  };


  const ListofRolePermissionStaff = () => {
    const FORM_DATA = new FormData();
    post(ApiURL.staff_list_role_permission, FORM_DATA).then((res) => {
      if (res?.status == true) {
        set_list_roll_permission(res?.role_permission_list);
      } else {
        const errors = res?.errors || {};
        set_errors(errors);
      }
    }).catch(() => {
      set_loader(false);

      ErrorToast(
        "Error",
        "Something went wrong"
      );
    });;
  };



  const View_ship_staff_details = () => {
    const FORM_DATA = new FormData();

    FORM_DATA.append(
      "staff_id",
      atob(staff_id)
    );

    post(
      ApiURL.staff_view_registered_staff,
      FORM_DATA
    ).then((res) => {
      if (res?.status) {
        const staff = res.staff_data;

        setInitialData(staff);

        set_first_name(staff.first_name || "");
        set_last_name(staff.last_name || "");
        set_email(staff.staff_email || "");
        set_date_of_birth(staff.date_of_birth || "");

        set_seafarer_id(staff.seafarer_id || "");
        set_nationality(staff.nationality || "");

        setDepartment(staff.department || "");


        set_role_permission_id(
          String(staff.staff_role_id) || ""
        );

        setSecurityCode(
          staff.master_code || ""
        );

        setActiveOvertime(
          staff.overtime_enabled
        );

        setBase_salary(
          staff.base_salary || 0
        );

        setFixed_overtime_hours(
          staff.fixed_overtime_hours || 0
        );

        setFixed_overtime_pay(
          staff.fixed_overtime_wages || 0
        );

        setPer_hour_overtime_pay(
          staff.overtime_wages_per_hour || 0
        );

        setSignOnDate(
          staff.sign_on_date || ""
        );

        setExpectedSignOffDate(
          staff.expected_sign_off_date || ""
        );

        setActualSignOffDate(
          staff.actual_sign_off_date || ""
        );

        setSelectedSlots(
          convertPlannedHoursToSlots(
            staff.planned_hours || []
          )
        );

        setCurrency(staff.currency || "");

      }
    }).catch(() => {
      set_loader(false);

      ErrorToast(
        "Error",
        "Something went wrong"
      );
    });;
  };

  const convertPlannedHoursToSlots = (
    plannedHours
  ) => {
    const slots = [];

    plannedHours.forEach((item) => {
      let current = moment(
        item.start,
        "HH:mm"
      );

      const end = moment(
        item.end,
        "HH:mm"
      );

      while (current.isBefore(end)) {
        const next = current
          .clone()
          .add(30, "minutes");

        slots.push(
          `${current.format(
            "H:mm"
          )}-${next.format("H:mm")}`
        );

        current = next;
      }
    });

    return slots;
  };

  const buildPlannedHours = (slots) => {
    if (!slots.length) return [];

    const convertToMinutes = (time) => {
      const [h, m] = time.split(":").map(Number);
      return h * 60 + m;
    };

    const sorted = [...slots]
      .map((slot) => {
        const [start, end] = slot.split("-");
        return {
          start,
          end,
          startMin: convertToMinutes(start),
          endMin: convertToMinutes(end),
        };
      })
      .sort((a, b) => a.startMin - b.startMin);

    const result = [];

    let current = sorted[0];

    for (let i = 1; i < sorted.length; i++) {
      const next = sorted[i];

      if (current.endMin === next.startMin) {
        current.end = next.end;
        current.endMin = next.endMin;
      } else {
        result.push({
          start: current.start,
          end: current.end,
        });
        current = next;
      }
    }

    result.push({
      start: current.start,
      end: current.end,
    });

    return result;
  };

  const handleMouseDown = (slot) => {
    const isSelected = selectedSlots.includes(slot);

    setDragMode(isSelected ? "remove" : "add");
    setIsDragging(true);

    setSelectedSlots((prev) => {
      if (isSelected) {
        return prev.filter((item) => item !== slot);
      }

      return [...prev, slot];
    });
  };

  const handleMouseEnter = (slot) => {
    if (!isDragging) return;

    setSelectedSlots((prev) => {
      const exists = prev.includes(slot);

      if (dragMode === "add") {
        return exists ? prev : [...prev, slot];
      }

      return exists ? prev.filter((item) => item !== slot) : prev;
    });
  };

  const handleMouseUp = () => {
    setIsDragging(false);
    setDragMode("add");
  };
  const appendIfChanged = (
    formData,
    key,
    currentValue,
    originalValue
  ) => {
    const current =
      currentValue ?? "";

    const original =
      originalValue ?? "";

    if (
      String(current) !==
      String(original)
    ) {
      if (
        current === "" &&
        key.includes("date")
      ) {
        return;
      }

      formData.append(
        key,
        current
      );
    }
  };

  const Edit_ship_Staff = () => {
    set_loader(true);

    const FORM_DATA = new FormData();

    FORM_DATA.append(
      "staff_id",
      atob(staff_id)
    );

    appendIfChanged(
      FORM_DATA,
      "first_name",
      first_name,
      initialData.first_name
    );

    appendIfChanged(
      FORM_DATA,
      "last_name",
      last_name,
      initialData.last_name
    );

    appendIfChanged(
      FORM_DATA,
      "date_of_birth",
      date_of_birth,
      initialData.date_of_birth
    );

    appendIfChanged(
      FORM_DATA,
      "staff_email",
      email,
      initialData.staff_email
    );

    appendIfChanged(
      FORM_DATA,
      "seafarer_id",
      seafarer_id,
      initialData.seafarer_id
    );

    appendIfChanged(
      FORM_DATA,
      "nationality",
      nationality,
      initialData.nationality
    );

    appendIfChanged(
      FORM_DATA,
      "department",
      department,
      initialData.department
    );

    appendIfChanged(
      FORM_DATA,
      "master_code",
      securityCode,
      initialData.master_code
    );

    appendIfChanged(
      FORM_DATA,
      "overtime_enabled",
      activeOvertime,
      initialData.overtime_enabled
    );

    appendIfChanged(
      FORM_DATA,
      "base_salary",
      base_salary,
      initialData.base_salary
    );

    appendIfChanged(
      FORM_DATA,
      "fixed_overtime_hours",
      fixed_overtime_hours,
      initialData.fixed_overtime_hours
    );

    appendIfChanged(
      FORM_DATA,
      "fixed_overtime_wages",
      fixed_overtime_pay,
      initialData.fixed_overtime_wages
    );

    appendIfChanged(
      FORM_DATA,
      "overtime_wages_per_hour",
      per_hour_overtime_pay,
      initialData.overtime_wages_per_hour
    );

    if (
      signOnDate &&
      signOnDate !== initialData.sign_on_date
    ) {
      FORM_DATA.append(
        "sign_on_date",
        signOnDate
      );
    }

    if (
      expectedSignOffDate &&
      expectedSignOffDate !==
      initialData.expected_sign_off_date
    ) {
      FORM_DATA.append(
        "expected_sign_off_date",
        expectedSignOffDate
      );
    }

    if (
      actualSignOffDate &&
      actualSignOffDate !==
      initialData.actual_sign_off_date
    ) {
      FORM_DATA.append(
        "actual_sign_off_date",
        actualSignOffDate
      );
    }

    const planned_hours =
      buildPlannedHours(
        selectedSlots
      );

    if (
      JSON.stringify(planned_hours) !==
      JSON.stringify(
        initialData.planned_hours || []
      )
    ) {
      FORM_DATA.append(
        "planned_hours",
        JSON.stringify(planned_hours)
      );
    }

    appendIfChanged(
      FORM_DATA,
      "currency",
      currency,
      initialData.currency
    );

    post(
      ApiURL.staff_edit_registered_staff,
      FORM_DATA
    ).then((res) => {
      set_loader(false);

      if (res?.status) {
        SuccessToast(
          "Success",
          "Staff updated successfully"
        );

        navigate(
          "/company-staff-list"
        );
      } else {
        set_errors(
          res?.errors || {}
        );
      }
    }).catch(() => {
      set_loader(false);

      ErrorToast(
        "Error",
        "Something went wrong"
      );
    });;
  };

  useEffect(() => {
    // ListofShipsPermissionStaff();
    ListofRolePermissionStaff();
    View_ship_staff_details();
  }, []);

  return (
    <div className="white-container">
      <h3>Edit Staff Registration Details </h3>
      <br />
      <div className="row">
        <div className="col-6">
          <div className="input-box">
            <label>First Name</label>
            <Input
              value={first_name}
              placeholder="First Name"
              onChange={(e) => {
                set_first_name(e.target.value);
                clearError("first_name");
              }}
            />
            {errors?.first_name && (
              <>
                <span style={{ color: "red" }}>{errors?.first_name}</span>
              </>
            )}
          </div>
        </div>
        <div className="col-6">
          <div className="input-box">
            <label>Last Name</label>
            <Input
              value={last_name}
              placeholder=" Last Name"
              onChange={(e) => {
                set_last_name(e.target.value);
                clearError("last_name");
              }}
            />
            {errors?.last_name && (
              <>
                <span style={{ color: "red" }}>{errors?.last_name}</span>
              </>
            )}
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-6">
          <div className="input-box">
            <label htmlFor="email">
              Email <span style={{ color: "red" }}>*</span>
            </label>
            <Input
              disabled
              value={email}
              id="email"
              placeholder="exampleABC@gmail.com"
              onChange={(e) => {
                set_email(e.target.value);
              }}
            />
            {errors?.email && <span style={{ color: "red" }}>{errors?.email}</span>}
          </div>
        </div>
        <div className="col-6">
          <div className="input-box">
            <label htmlFor="email">Date of Birth</label>
            <Input
              value={date_of_birth}
              type="date"
              id="date_of_birth"
              placeholder="date_of_birth"
              onChange={(e) => {
                set_date_of_birth(e.target.value);
                clearError("date_of_birth"); // matched the current error display key
              }}
            />
            {errors?.email && <span style={{ color: "red" }}>{errors?.email}</span>}
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-6">
          <div className="input-box">
            <label>Employee ID</label>

            <Input
              value={seafarer_id}
              onChange={(e) =>
                set_seafarer_id(
                  e.target.value
                )
              }
            />
          </div>
        </div>

        <div className="col-6">
          <div className="input-box">
            <label>Nationality</label>
            <CountryDropdown
              style={{ width: "100%", height: "32px" }}
              value={nationality}
              onChange={(value) => {
                set_nationality(value);
                clearError("nationality");
              }}
              className="ant-input css-dev-only-do-not-override-djtmh8 ant-input-outlined"
            />
            {errors?.nationality && <span style={{ color: "red" }}>{errors?.nationality}</span>}
          </div>

        </div>
      </div>

      <div className="row">
        <div className="col-6">
          <div className="input-box">
            <label>
              Rank <span style={{ color: "red" }}>*</span>
            </label>
            <Select
              disabled
              placeholder=" --- Select Designation --- "
              style={{ width: "100%" }}
              value={role_permission_id}
            >
              {list_roll_permission?.length > 0 && (
                <>
                  {list_roll_permission.map((role) => (
                    <>
                      {role.status && !role.soft_delete && (
                        <>
                          <Select.Option value={String(role.id)}>{` ${role.title}`}</Select.Option>
                        </>
                      )}
                    </>
                  ))}
                </>
              )}
            </Select>
            {errors?.role_permission_id && (
              <>
                <span style={{ color: "red" }}>{errors?.role_permission_id}</span>
              </>
            )}
          </div>
        </div>

        <div className="col-6">
          <div className="input-box">
            <label>Department</label>
            <Select
              placeholder="--- Select Department ---"
              style={{ width: "100%" }}
              value={department}
              onChange={(value) => {
                setDepartment(value);
                clearError("department");
              }}
            >
              <Select.Option value="Deck">Deck</Select.Option>
              <Select.Option value="Engine">Engine</Select.Option>
            </Select>

            {errors?.department && (
              <span style={{ color: "red" }}>{errors?.department}</span>
            )}
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-6">
          <></>
        </div>

        {(Number(role_permission_id) === 10 ||
          Number(role_permission_id) === 13) && (
            <div className="col-6">
              <div className="input-box">
                <label>Security Code</label>
                <Input
                  maxLength={6}
                  value={securityCode}
                  placeholder="Security Code"
                  onChange={(e) => {
                    setSecurityCode(e.target.value);
                  }}
                />

                {errorSecurity && (
                  <span style={{ color: "red", fontSize: "11px" }}>
                    {errorSecurity}
                  </span>
                )}
              </div>
            </div>
          )}
      </div>

      <div className="row">
        <div className="col-4">
          <div className="input-box">
            <label>
              Sign On Date
            </label>

            <Input
              type="date"
              value={signOnDate}
              onChange={(e) =>
                setSignOnDate(
                  e.target.value
                )
              }
            />
          </div>
        </div>

        <div className="col-4">
          <div className="input-box">
            <label>
              Expected Sign Off
            </label>

            <Input
              type="date"
              value={
                expectedSignOffDate
              }
              onChange={(e) =>
                setExpectedSignOffDate(
                  e.target.value
                )
              }
            />
          </div>
        </div>

        <div className="col-4">
          <div className="input-box">
            <label>
              Actual Sign Off
            </label>

            <Input
              type="date"
              value={
                actualSignOffDate
              }
              onChange={(e) =>
                setActualSignOffDate(
                  e.target.value
                )
              }
            />
          </div>
        </div>
      </div>

      <div
        style={{
          marginTop: "15px",
          width: "100%",
          display: "flex",
          justifyContent: "flex-start",
          alignItems: "center",
        }}
      >
        <label
          style={{
            display: "flex",
            alignItems: "center",
            gap: "10px",
            cursor: "pointer",
          }}
        >
          <input
            type="checkbox"
            checked={activeOvertime}
            onChange={(e) => setActiveOvertime(e.target.checked)}
            style={{
              width: "18px",
              height: "18px",
              cursor: "pointer",
            }}
          />

          <span>Enable Overtime</span>
        </label>
      </div>
      {activeOvertime && (
        <>
          <div className="row">
            <div className="col-6">
              <div className="input-box">
                <label>
                  Currency <span style={{ color: "red" }}>*</span>
                </label>

                <CurrencyDropdown
                  value={currency}
                  onChange={setCurrency}
                />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-6">
              <div className="input-box">
                <label>
                  Base Salary
                </label>

                <Input
                  addonBefore={getCurrencySymbol(currency)}
                  value={base_salary}
                  onChange={(e) =>
                    setBase_salary(
                      e.target.value
                    )
                  }
                />
              </div>
            </div>

            <div className="col-6">
              <div className="input-box">
                <label>
                  Fixed Overtime Hours
                </label>

                <Input
                  addonBefore={getCurrencySymbol(currency)}
                  value={
                    fixed_overtime_hours
                  }
                  onChange={(e) =>
                    setFixed_overtime_hours(
                      e.target.value
                    )
                  }
                />
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-6">
              <div className="input-box">
                <label>
                  Fixed Overtime Wages
                </label>

                <Input
                  addonBefore={getCurrencySymbol(currency)}
                  value={
                    fixed_overtime_pay
                  }
                  onChange={(e) =>
                    setFixed_overtime_pay(
                      e.target.value
                    )
                  }
                />
              </div>
            </div>

            <div className="col-6">
              <div className="input-box">
                <label>
                  Overtime Per Hour
                </label>

                <Input
                  addonBefore={getCurrencySymbol(currency)}
                  value={
                    per_hour_overtime_pay
                  }
                  onChange={(e) =>
                    setPer_hour_overtime_pay(
                      e.target.value
                    )
                  }
                />
              </div>
            </div>
          </div>
        </>
      )}

      <div style={{ marginTop: "40px", width: "100%" }}>
        <h3>Rank Default Schedule</h3>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(48, 1fr)",
            marginBottom: "4px",
            width: "100%",
          }}
        >
          {Array.from({ length: 24 }, (_, hour) => (
            <div
              key={hour}
              style={{
                gridColumn: "span 2",
                textAlign: "center",
                fontSize: "9px",
                fontWeight: "bold",
              }}
            >
              {hour}
            </div>
          ))}
        </div>

        {/* Main Timeline */}
        <div
          onMouseUp={handleMouseUp}
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(48, 1fr)",
            width: "100%",
            userSelect: "none",
            borderTop: "2px solid #555",
            borderBottom: "2px solid #555",
            borderLeft: "2px solid #555",
          }}
        >
          {Array.from({ length: 48 }, (_, index) => {
            const hour = Math.floor(index / 2);

            const label =
              index % 2 === 0
                ? `${hour}:00-${hour}:30`
                : `${hour}:30-${hour + 1}:00`;

            const isSelected = selectedSlots.includes(label);

            return (
              <div
                key={index}
                onMouseDown={() => handleMouseDown(label)}
                onMouseEnter={() => handleMouseEnter(label)}
                style={{
                  height: "22px",
                  background: isSelected ? "grey" : "white",
                  cursor: "pointer",
                  borderRight:
                    index % 2 === 0 ? "1px solid #ccc" : "2px solid #555",
                }}
              />
            );
          })}
        </div>
      </div>

      <br />


      <Button className="save_btn" onClick={Edit_ship_Staff} type="primary" loading={loader}>
        Save
      </Button>
    </div>
  );
}

export default EditStaff;
